const messages = {
  title: "Underhåll!",
  description:
    'Nödvändigt underhållsarbete utförs för närvarande på servrarna.<br/><br/>Därför har du för närvarande inte tillgång till <b>BRIDGESTONE <span class="text-danger">PLUS</span></b>.<br/><br/>Vi ber om ditt tålamod och tackar dig för din förståelse.<br/><br/> Ditt Bridgestone-team',
}
export default {
  messages
}
